<template>
  <div>
    <LoginComponent />
  </div>
</template>

<script>
import LoginComponent from '@/components/LoginComponent.vue';

export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$root.isLoggedIn = true;
    });
  },
  
  beforeRouteLeave(to, from, next) {
    this.$root.isLoggedIn = false;
    next();
  },
  components: {
    LoginComponent
},
};
</script>